import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 中古資産 */
enum SecondhandAsset {
  normal = '0',
  secondhand = '1',
}

const nameConfig = {
  normal: new Map([[Locale.ja, '通常資産']]),
  secondhand: new Map([[Locale.ja, '中古資産']]),
};

const toEnum = rawValueToEnum(SecondhandAsset, SecondhandAsset.normal);
const toDisplay = enumToName(SecondhandAsset, nameConfig);
const toDisplayWithPrefix = enumToName(SecondhandAsset, nameConfig, { prefix: true });

export const secondhandAsset = {
  enum: SecondhandAsset,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { SecondhandAsset };
